// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Polygon } from "./Polygon";
import {
  PolygonFromJSON,
  PolygonFromJSONTyped,
  PolygonToJSON,
  PolygonToJSONTyped,
} from "./Polygon";

/**
 *
 * @export
 * @interface DrawOnMapInput
 */
export interface DrawOnMapInput {
  /**
   *
   */
  polygon: Polygon;
}

/**
 * Check if a given object implements the DrawOnMapInput interface.
 */
export function instanceOfDrawOnMapInput(value: object): value is DrawOnMapInput {
  if (!("polygon" in value) || value["polygon"] === undefined) return false;
  return true;
}

export function DrawOnMapInputFromJSON(json: any): DrawOnMapInput {
  return DrawOnMapInputFromJSONTyped(json, false);
}

export function DrawOnMapInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DrawOnMapInput {
  if (json == null) {
    return json;
  }
  return {
    polygon: PolygonFromJSON(json["polygon"]),
  };
}

export function DrawOnMapInputToJSON(json: any): DrawOnMapInput {
  return DrawOnMapInputToJSONTyped(json, false);
}

export function DrawOnMapInputToJSONTyped(
  value?: DrawOnMapInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    polygon: PolygonToJSON(value["polygon"]),
  };
}
